import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators';
import { AuthenticationSelectors } from '../authentication';

const PLANT_PLACEHOLDER = '__plant__';
const ORCH_SUFFIX_PLACEHOLDER = '__orchSuffix__';
const PLANT_WAIT_TIMEOUT_MS = 30000;
const ORCH_PLANTS: ReadonlySet<string> = new Set(['MULTI', 'JUSDA', 'CTP']);

export const plantInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  const needsPlant = req.url.includes(PLANT_PLACEHOLDER);
  const needsOrch = req.url.includes(ORCH_SUFFIX_PLACEHOLDER);
  if (!needsPlant && !needsOrch) {
    return next(req);
  }

  return store.select(AuthenticationSelectors.activePlant).pipe(
    filter((plant): plant is string => !!plant),
    take(1),
    timeout(PLANT_WAIT_TIMEOUT_MS),
    switchMap((plant): Observable<HttpEvent<unknown>> => {
      const orchSuffix = ORCH_PLANTS.has(plant.toUpperCase()) ? 'Orch' : '';
      const resolvedUrl = req.url
        .replace(PLANT_PLACEHOLDER, plant.toLowerCase())
        .replace(ORCH_SUFFIX_PLACEHOLDER, orchSuffix);
      return next(req.clone({ url: resolvedUrl }));
    }),
    catchError((err): Observable<HttpEvent<unknown>> => {
      if (err && err.name === 'TimeoutError') {
        return throwError(
          (): Error =>
            new Error(
              `PlantInterceptor: no active plant resolved within ${PLANT_WAIT_TIMEOUT_MS}ms for ${req.url}`,
            ),
        );
      }
      return throwError((): unknown => err);
    }),
  );
};
